// Congiuración Información usuarios: Demo y Producción

// DEMO
export const URL_SERVICIOS = 'https://cidscixdemo.cixteam.com/datasnap/rest/TServerMethods1';

// PRODUCCIÓN
// export const URL_SERVICIOS = 'https://cidscix.cixteam.com/datasnap/rest/TServerMethods1';
 export const URL_CONSULTAS = 'https://cidsdemo.cixteam.com/datasnap/rest/TDSConsultas';
 export const URL_NOTIFICACIONES = 'http://127.0.0.1:3000';
